import React, { useState } from 'react';
import { motion } from 'framer-motion';
import EmigoInteractiveIcon from './EmigoInteractiveIcon';
import AmbientThreads from './AmbientThreads';
const Hero = () => {
  const [hasBeenTapped, setHasBeenTapped] = useState(false);
  return <section id="hero" className="relative overflow-hidden pt-20 pb-24 md:pt-28 md:pb-32" style={{
    backgroundColor: 'var(--cream)'
  }} data-id="element-155">
      <AmbientThreads variant="hero" data-id="element-156" />

      <div className="relative max-w-6xl mx-auto px-6 sm:px-8 lg:px-10 text-center" data-id="element-157">
        {/* Small pre-title */}
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: [0.16, 1, 0.3, 1]
      }} className="mb-8 inline-flex items-center gap-2 px-4 py-1.5 rounded-full" style={{
        backgroundColor: 'var(--peach)',
        color: 'var(--coral-deep)'
      }} data-id="element-158">
          <span className="text-xs font-medium tracking-wider uppercase" data-id="element-159">
            emotionally intelligent texting
          </span>
        </motion.div>

        {/* Main headline */}
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.9,
        delay: 0.1,
        ease: [0.16, 1, 0.3, 1]
      }} className="text-5xl md:text-6xl lg:text-7xl font-normal leading-[1.05] tracking-tight mb-6" style={{
        color: 'var(--navy)',
        fontFamily: "'DM Serif Display', serif"
      }} data-id="element-160">
          <span className="inline-flex items-center gap-3 md:gap-4 align-middle" data-id="element-161">
            <EmigoInteractiveIcon onTap={() => setHasBeenTapped(true)} data-id="element-162" />
            <span style={{
            color: 'var(--coral)'
          }} data-id="element-163">
              One Tap
            </span>
          </span>
          <br data-id="element-164" />
          <span data-id="element-165">
            is all{' '}
            <em className="italic" style={{
            color: 'var(--navy-soft)'
          }} data-id="element-166">
              it takes
            </em>
          </span>
        </motion.h1>

        {/* Sub-headline */}
        <motion.p initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.9,
        delay: 0.25,
        ease: [0.16, 1, 0.3, 1]
      }} className="max-w-2xl mx-auto text-lg md:text-xl leading-relaxed mb-10" style={{
        color: 'var(--muted)'
      }} data-id="element-167">
          A calmer layer between you and your messages. Reframe what you feel.
          Interpret what they mean. Reply without the spiral.
        </motion.p>

        {/* CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: [0.16, 1, 0.3, 1]
      }} className="flex flex-col sm:flex-row items-center justify-center gap-5" data-id="element-168">
          <motion.a whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} href="https://apps.apple.com/us/app/emigo-better-texting/id6748092950" target="_blank" rel="noopener noreferrer" className="inline-block" data-id="element-169">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/55BSmF1FDX8kQyzwZAZdd8/download-on-the-app-store.svg" alt="Download on the App Store" className="h-12" data-id="element-170" />
          </motion.a>
          <p className="text-sm italic" style={{
          color: 'var(--muted-warm)'
        }} data-id="element-171">
            Free. No sign-up. No personal info.
          </p>
        </motion.div>

        {/* Tiny proof line */}
        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 0.6
      }} className="mt-12 text-xs tracking-widest uppercase" style={{
        color: 'var(--muted-warm)'
      }} data-id="element-172">
          Works across messaging, email, and work chat apps — no app switching
        </motion.p>
      </div>
    </section>;
};
export default Hero;